import React from "react";
import { useTranslation } from "react-i18next";

import { PriceBlockProps } from "@models/components/user.model";
import { applyLocalization } from "@services/common.service";

import Price from "../Price/Price";

const PriceBlock: React.FC<PriceBlockProps> = ({ bookingDetails }) => {
  const { t } = useTranslation();
  const vatSubLabel =
    bookingDetails?.vatPercentage || bookingDetails?.vatHandlingType
      ? t("exclusiveValue", {
          value: bookingDetails?.vatPercentage,
          vatHandlingType: t(
            bookingDetails?.vatHandlingType?.toLocaleLowerCase()
          ),
        })
      : null;

  return (
    <div className="total-prize-section mb-2" data-testid="price-block">
      <Price
        label={t("priceOfTheUnit", {
          resource: applyLocalization(
            bookingDetails?.resourceType?.terminology?.singular
          ),
        })}
        recursiveBooking={bookingDetails?.recursiveBooking}
        labelClass="unit-prize-label"
        value={`${bookingDetails?.currency || ""} ${bookingDetails?.basePrice || ""}`}
      />
      {bookingDetails?.vat && bookingDetails?.vatPercentage && (
        <Price
          label={t("VAT")}
          labelClass="unit-vat-label"
          subLabel={vatSubLabel}
          value={`${bookingDetails?.currency || ""} ${bookingDetails?.vat || ""}`}
        />
      )}
      <Price
        customClass="mt-2"
        label={t("totalPriceToPay")}
        recursiveBooking={bookingDetails?.recursiveBooking}
        value={`${bookingDetails?.currency || ""} ${bookingDetails?.totalPrice || ""}`}
      />
    </div>
  );
};

export default PriceBlock;
